import { tableTheme } from 'components/FlexTable/layout/theme';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import styled from 'styled-components';

export const FlexTableV2SettingsContainer = styled.div`
  --settings-container-column-gap: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: end;
  column-gap: var(--settings-container-column-gap);
  padding-block: 0.75rem;
  font-size: ${tableTheme.fontSize.medium};

  & > :not(:last-child) {
    position: relative;
    display: flex;
    align-items: center;

    ::after {
      pointer-events: none;
      position: absolute;
      content: '';
      right: calc(var(--settings-container-column-gap) / 2 * -1);
      width: 1px;
      height: 75%;
      top: auto;
      background-color: ${tableTheme.colors.primary};
    }
  }
`;

export const FlexTableV2ClearSettings = styled.div`
  --clear-settings-column-gap: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  column-gap: var(--clear-settings-column-gap);

  --clear-settings-text-width: 0;
  &:hover {
    --clear-settings-column-gap: 0.5em;
    --clear-settings-text-width: 14ch;
  }

  &:active {
    transform: scale(0.96);
  }

  > svg {
    display: inline;
  }

  > span {
    display: inline-block;
    max-width: var(--clear-settings-text-width);
    white-space: nowrap;
    overflow: hidden;
    transition: max-width 0.2s ease-in-out;
  }

  transition: transform 0.1s ease-in-out;
`;

export const FlexTableV2MainContainer = styled.div`
  display: contents;
`;

export const FlexTableV2ScrollContainer = styled.div`
  overflow-y: auto;
  overflow-x: ${(props) => (props.$overflowX ? 'auto' : 'hidden')};
  position: relative;
  height: auto;
  width: 100%;
  max-width: 100%;
  min-height: 220px;
`;

export const FlexTableV2Table = styled.table`
  width: ${(props) => (props.$overflowX ? 'auto' : '100%')};
  min-width: ${(props) => (props.$overflowX ? 'auto' : '100%')};
  background-color: white;
  display: grid;
  table-layout: fixed;
  border-collapse: collapse;
  border: none;

  & > tbody > tr {
    border-bottom: 1px solid #e0e0e0;
  }
`;

export const FlexTableV2THead = styled.thead`
  display: grid;
  position: sticky;
  z-index: 1;
  background-color: #f6f9fc;
  width: 100%;
  font-weight: bold;
`;

export const FlexTableV2TBody = styled.tbody`
  tr {
    background-color: white;
  }

  tr:hover {
    background-color: #f1f1f1;
  }

  tr {
    border: none;
  }
`;

export const FlexTableV2TR = styled.tr`
  display: flex;
  width: ${(props) => (props.$overflowX ? 'fit-content' : '100%')};
  min-width: ${(props) => (props.$overflowX ? 'auto' : '100%')};

  tbody & {
    position: absolute;
  }

  &.table-active {
    background-color: rgba(0, 123, 255, 0.1);
  }

  tbody &:hover {
    background-color: #ddd !important;
  }
`;

export const FlexTableV2TH = styled.th`
  display: flex;
  flex-direction: column;
  flex-grow: ${(props) => (props.$overflowX ? 0 : 1)};
  flex-shrink: 1;
  min-width: 0;
  cursor: pointer;
  font-size: ${tableTheme.fontSize.small};
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
  position: relative;
  padding: 10px;
  text-align: left;
  background-color: #f6f9fc;
  border: none;
`;

export const FlexTableV2TD = styled.td`
  display: flex;
  flex-grow: ${(props) => (props.$overflowX ? 0 : 1)};
  flex-shrink: 1;
  min-width: 0;
  color: ${tableTheme.colors.textPrimary};
  vertical-align: middle;
  padding: 10px;
  font-size: ${tableTheme.fontSize.medium};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: inherit;
  border: none;
`;

export const FlexTableV2Resizer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 5px;
  cursor: col-resize;
  user-select: none;
  touch-action: none;

  .isResizing,
  :hover {
    opacity: 1;
  }
`;

export const FlexTableV2PaginationContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FlexTableV2PaginationSkipToPage = styled.div`
  position: absolute;
  right: 0;
  display: flex;
  column-gap: 0.5rem;
`;

export const FlexTableV2Dropdown = styled(Dropdown)``;

export const FlexTableV2DropdownToggle = styled(DropdownToggle)`
  all: unset;
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  column-gap: 0.5rem;
  margin-right: unset !important;

  &:hover,
  &:active,
  &:focus {
    background: none !important;
    box-shadow: none !important;
    color: inherit;
    transform: none;
  }
`;

export const FlexTableV2SettingsToggle = styled(FlexTableV2DropdownToggle)`
  cursor: pointer;

  --settings-dropdown-column-gap: 0;
  column-gap: var(--settings-dropdown-column-gap);

  --settings-dropdown-text-width: 0;

  &:hover {
    --settings-dropdown-column-gap: 0.5em;
    --settings-dropdown-text-width: 14ch;
  }

  &:active {
    transform: scale(0.96);
  }

  > svg {
    display: inline;
  }

  > span {
    display: inline-block;
    max-width: var(--settings-dropdown-text-width);
    white-space: nowrap;
    overflow: hidden;
    transition: max-width 0.2s ease-in-out;
  }

  transition: transform 0.1s ease-in-out;
`;

export const FlexTableV2DropdownMenu = styled(DropdownMenu)`
  z-index: 1060 !important;
`;

export const FlexTableV2DropdownItem = styled(DropdownItem)`
  padding: 0.25rem 1rem !important;
  display: flex !important;
  align-items: center !important;
  gap: 0.5rem;
  cursor: pointer;

  &:hover {
    background-color: ${tableTheme.colors.hover};
  }

  input {
    cursor: pointer;
  }

  label {
    margin: unset;
  }
`;

export const FlexTableV2ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
`;

export const FlexTableV2Divider = styled.div`
  background-color: transparent;
  height: 1px;
  width: 100%;
`;
